export default {
    title: 'Auswertungen',

    noReportsToUse: 'Für die ausgewählten Vorgänge sind keine Auswertungen verfügbar.',

    report: 'Auswertung',
    reportNotAvailableForProcesses: 'Die Auswertung ist für die folgenden Vorgänge nicht verfügbar: {processes}.',
    reportWillNotBeCreatedFor: 'Diese Vorgänge werden bei dieser Auswertung nicht berücksichtigt.',
    showNewStatusSelection: 'Neuen Status setzen',
    showNewStatusSelectionHelpText: 'Wenn die Auswertung erzeugt wurde, kann für alle ausgewählten Vorgänge ein neuer Status gesetzt werden.',
    newStatus: 'Neuer Status',
    statusNotAvailableForProcesses: 'Der Status ist für die folgenden Vorgänge nicht verfügbar: {processes}.',
    statusWillNotBeChanged: 'Der Status dieser Vorgänge wird nicht geändert.',
    usePersonalSignature: 'Persönliche Unterschrift verwenden',
    usePersonalSignatureHelpText: 'Die persönliche Unterschrift, falls vorhanden, wird in die Auswertung eingedruckt.',

    doReport: 'Auswertung erzeugen',

    digitalDocumentsReport: 'Auswertung mit digitalen Dokumenten',
    digitalDocumentsReportHelpText: 'Hier wird die oben ausgewählte Auswertung erzeugt und alle Vorgangsdokumente inklusive den Uploads werden an die Auswertungsliste angehängt.',
    doDigitalDocumentsReport: 'Auswertung mit digitalen Dokumenten erzeugen',

    noReportCreated: 'Es konnte keine Auswertung erzeugt werden.',
    errorOnCreation: 'Fehler beim Erzeugen der Auswertung.',
    errorOnLoad: 'Fehler beim Laden.',
}